export const style = {
  box: {
    marginBottom: `30px`
  },
  h4: {
    fontSize: `1.4em`,
    color: `#A94545`,
    fontWeight: 300,
    margin: `0 0 14px 0`
  },
  icon: {
    color: `white`,
    background: `#A94545`,
    fontSize: `17px`,
    textAlign: `center`,
    width: `35px`,
    height: `35px`,
    lineHeight: `35px`,
    borderRadius: `50%`,
    marginRight: `10px`
  },
  p: {
    marginBottom: `20px`,
    fontSize: `14px`,
    lineHeight: `1.4`,
    color: `#666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Home/style/perks.js